export default __webpack_public_path__ + "static/property-decription-map-t-38defb0cdb68d57aaaa12817a390738f.jpg";